import {GetHelpCenterArticleResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/help_center/v1/service.types';
import {useHistory, useQueryParamsCallback} from '@aboutyou/router';
import {Button as BaseButton} from '@aboutyou/ui-components';
import {addParamsToUrl} from '@aboutyou/utils';
import React from 'react';
import styled, {css} from 'styled-components';
import {
  PathIntent,
  getAppIntentUrlForDevices,
} from '../../../features/AppRedirect/helpers';
import {useAppUrlParams} from '../../Checkout/hooks/useAppUrlParams';

interface HelpCenterArticleCtaViewProps {
  ctaLink?: GetHelpCenterArticleResponse['ctaLink'] & {appIntent?: PathIntent};
  isFullWidth?: boolean;
}

export const HelpCenterArticleCtaView = ({
  ctaLink,
  isFullWidth = false,
}: HelpCenterArticleCtaViewProps) => {
  const {location} = useHistory();
  const {device} = useAppUrlParams();
  const getQueryParams = useQueryParamsCallback();
  const queryParams = getQueryParams();
  const getCtaHref = (intent: PathIntent | undefined, url: string) => {
    if (intent) {
      if (device === 'android' || device === 'ios') {
        return getAppIntentUrlForDevices({
          device,
          intent,
          searchParams: location.search,
        });
      }
    }

    return `${url}?backTo=${addParamsToUrl(location.pathname, queryParams)}`;
  };
  if (ctaLink != null) {
    const ctaHref = getCtaHref(ctaLink.appIntent, ctaLink.linkTarget.url);
    return (
      <CtaContainer $fullWidth={isFullWidth}>
        <Button href={ctaHref}>{ctaLink.label}</Button>
      </CtaContainer>
    );
  }
  return null;
};

const Button = styled(BaseButton)`
  flex: 1;
  display: flex;

  > span {
    flex: 1;
  }
`;

const CtaContainer = styled.div<{$fullWidth: boolean}>`
  margin-bottom: 60px;

  ${props =>
    props.$fullWidth &&
    css`
      width: 100%;
      display: flex;
    `}
`;
